/*
 * Makri "Hemen al" (2026-10-14). Seçili varyantı ve adedi ürün formundan alıp sepete ekler.
 * Sepet toplamı asgari sipariş tutarındaysa (tema ayarı) doğrudan /checkout'a gider; altındaysa
 * sepet çekmecesini açar — çekmece asgari tutar uyarısını ve devre dışı "Siparişi tamamla"yı gösterir.
 */
if (!customElements.get('makri-buy-now')) {
  customElements.define(
    'makri-buy-now',
    class MakriBuyNow extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.button.addEventListener('click', this.onClick.bind(this));
      }

      get form() {
        return document.getElementById(this.dataset.formId);
      }

      async onClick() {
        const form = this.form;
        if (!form || this.button.getAttribute('aria-disabled') === 'true') return;
        const submit = form.querySelector('[type="submit"][name="add"]');
        if (submit && (submit.disabled || submit.getAttribute('aria-disabled') === 'true')) return;

        const productForm = form.closest('product-form');
        const drawer = document.querySelector('cart-drawer');
        this.setLoading(true);
        productForm?.handleErrorMessage?.();

        const formData = new FormData(form);
        if (drawer) {
          formData.append('sections', drawer.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
        }
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = formData;

        try {
          const added = await fetch(`${routes.cart_add_url}`, config).then((response) => response.json());
          if (added.status) {
            productForm?.handleErrorMessage?.(added.description || added.message);
            this.setLoading(false);
            return;
          }

          const cart = await fetch(`${routes.cart_url}.js`).then((response) => response.json());
          const minimum = parseInt(this.dataset.minOrder, 10) || 0;
          if (cart.total_price >= minimum) {
            window.location.href = '/checkout';
            return;
          }

          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'makri-buy-now', productVariantId: formData.get('id'), cartData: added });
          if (drawer && added.sections) {
            drawer.renderContents(added);
            drawer.classList.remove('is-empty');
          } else {
            window.location = window.routes.cart_url;
          }
        } catch (error) {
          console.error(error);
          window.location = window.routes.cart_url;
        }
        this.setLoading(false);
      }

      setLoading(loading) {
        this.button.classList.toggle('loading', loading);
        this.button.toggleAttribute('aria-disabled', loading);
        this.querySelector('.loading__spinner')?.classList.toggle('hidden', !loading);
      }
    }
  );
}
